import { EntityHolisticlock } from "../../entity/EntityHolisticlock";

export class DtoHolisticlocksPostRes extends EntityHolisticlock {}
